// extracted by mini-css-extract-plugin
export var socialIconWrapper = "LinkIcon-module--socialIconWrapper--IGhjE";